import React, { useState, useRef, useEffect, } from 'react';

import Loader from 'react-loader-spinner';
import Switch from "react-switch";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp, faAngleDown, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { withFirebase } from '../../firebase';
import { data } from 'jquery';


const TournamentForm = (props) => {

    const { onClose, showModal } = props;
    const [user, setUser] = useState(props.user);
    const inputFocusRef = useRef();

    useEffect(() => {
        inputFocusRef.current.focus();
        setUser(props.user)
    }, [props.user])

    const [saving, setSaving] = useState(false)

    const email = user.email || '';
    const [tournaments, setTournaments] = useState(user.tournaments || '');
    const [blocked, setBlocked] = useState(user.blocked || false);

    const onSubmit = (e) => {
        e.preventDefault();
        const invalid = tournaments === '';
        if (!invalid && !saving) {
            setSaving(true);

            let data = { tournaments: tournaments };


            if (blocked !== user.blocked) {
                data.uid = user.uid;
                data.blocked = blocked;
                const enableDisableUser = props.firebase.enableDisableUser();

                enableDisableUser(data)
                    .then((result) => {
                        setSaving(false);
                        onClose();
                    })
                    .catch((error) => {
                        setSaving(false);
                        console.log("Error: ", error);
                        showModal("Error", "Ocurrió un error al guardar los datos del usuario. Compruebe los datos e intentelo de nuevo.")
                        onClose();
                    });
            } else {

                props.firebase.premiumUserDoc(user.uid).update(data)
                    .then(() => {
                        setSaving(false);
                        onClose();
                    })
                    .catch((error) => {
                        setSaving(false);
                        console.log("Error: ", error);
                        showModal("Error", "Ocurrió un error al guardar los datos del usuario. Compruebe los datos e intentelo de nuevo.")
                        onClose();
                    });
            }
        }
    }

    const invalid = tournaments === '';
    return (
        <div className="">
            <span className="font-weight-bolder ml-2">Editar Usuario</span>

            <form onSubmit={onSubmit}>

                <div className="row m-0">
                    <div className="col row pl-0 pr-0 m-0">

                        <div className="col-12 col-md-6 p-1">
                            <label className="small text-secondary mb-0 ml-1" htmlFor="title">Usuario:</label>
                            <input ref={inputFocusRef} className="form-control form-control-sm" value={email} type="text" id="title" name="title" placeholder="..." readOnly={true} />
                        </div>

                        <div className="col-12 col-md-6 p-1">
                            <label className="small text-secondary mb-0 ml-1" htmlFor="title">Torneos:</label>
                            <input ref={inputFocusRef} className="form-control form-control-sm" value={tournaments} type="number" min="0" id="tournaments" name="tournaments" placeholder="3"
                                onChange={(e) => setTournaments(e.target.value != '' ? parseInt(e.target.value, 10) : 0)} />
                        </div>

                    </div>

                    <div className="col-12 p-0 d-inline-flex">
                        <label htmlFor="switch" className="align-self-center m-1 small">
                            <span className="mr-1">Bloqueado</span>
                            <Switch
                                onChange={(checked) => setBlocked(checked)}
                                checked={blocked}
                                uncheckedIcon={<p className="small text-white font-weight-bold text-center pt-1">No</p>}
                                checkedIcon={<p className="small text-white font-weight-bold text-center pt-1">Si</p>}
                                onColor="#f44336"
                                offColor="#90a4ae"
                                handleDiameter={16}
                                height={22}
                                width={44}
                                id="switch"
                            />
                        </label>

                        {(!saving) ?
                            <div className="flex-fill d-flex flex-row-reverse p-0 mt-2">
                                <button disabled={invalid} type="submit" className="col-auto btn btn-sm btn-success m-1">Guardar</button>
                                <button onClick={onClose} className="col-auto btn btn-sm btn-secondary m-1">Cancelar</button>
                            </div>
                            :
                            <div className="flex-fill d-flex flex-row-reverse p-0 mt-2">
                                <Loader className=""
                                    type="ThreeDots"
                                    color="#263238"
                                    height={39}
                                    width={50}
                                    timeout={0} />
                            </div>
                        }
                    </div>
                </div>
            </form>
        </div>
    )

}

export default withFirebase(TournamentForm);
